(() => {
  const SELECTOR = '[data-br-gallery-proof-enhanced]';

  function setup(scope = document) {
    const galleries = scope.querySelectorAll ? scope.querySelectorAll('media-gallery') : [];
    galleries.forEach((gallery) => {
      if (gallery.matches(SELECTOR)) return;

      const source = document.querySelector('.br-ba-image img');
      const viewer = gallery.querySelector('.product__media-list');
      const firstSlide = viewer?.querySelector('.product__media-item');
      if (!source || !viewer || !firstSlide) return;

      const mediaId = gallery.id.replace('MediaGallery-', '') + '-br-before-after';
      const slide = document.createElement('li');
      slide.id = 'Slide-' + mediaId;
      slide.className = 'product__media-item grid__item slider__slide';
      slide.dataset.mediaId = mediaId;

      const link = document.createElement('a');
      link.className = 'br-gallery-proof';
      link.href = '#br-before-after';
      link.setAttribute('aria-label', (source.alt || 'Ürün') + ' görselini incele');

      const image = source.cloneNode(true);
      image.loading = 'eager';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');

      const label = document.createElement('span');
      label.className = 'br-gallery-proof__label';
      label.textContent = 'Gerçek kullanım · Öncesi / Sonrası';

      link.append(image, label);
      slide.append(link);
      firstSlide.insertAdjacentElement('afterend', slide);

      const thumbnails = gallery.querySelector('.thumbnail-list');
      if (thumbnails) {
        const item = document.createElement('li');
        item.className = 'thumbnail-list__item slider__slide';
        item.dataset.target = mediaId;
        item.dataset.mediaPosition = '2';

        const button = document.createElement('button');
        button.className = 'thumbnail global-media-settings global-media-settings--no-shadow br-gallery-proof-thumb';
        button.type = 'button';
        button.setAttribute('aria-label', 'Öncesi ve sonrası görselini galeride aç');
        button.setAttribute('aria-controls', gallery.querySelector('slider-component')?.id || '');

        const thumb = source.cloneNode(true);
        thumb.loading = 'eager';
        thumb.removeAttribute('srcset');
        thumb.removeAttribute('sizes');
        button.append(thumb);
        item.append(button);
        thumbnails.firstElementChild?.insertAdjacentElement('afterend', item);

        button.addEventListener('click', () => {
          gallery.querySelectorAll('.product__media-item').forEach((node) => node.classList.remove('is-active'));
          gallery.querySelectorAll('.thumbnail').forEach((node) => node.removeAttribute('aria-current'));
          slide.classList.add('is-active');
          button.setAttribute('aria-current', 'true');
          slide.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
        });
      }

      const total = gallery.querySelector('.slider-counter--total');
      if (total) total.textContent = String(viewer.querySelectorAll('.product__media-item').length);
      gallery.setAttribute('data-br-gallery-proof-enhanced', '');
    });
  }

  const boot = () => requestAnimationFrame(() => setup(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
